/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaar_Vijf2Inputs */

const nl_enums_leerjaar_vijf2 = /** @type {(inputs: Enums_Leerjaar_Vijf2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerjaar 5`)
};

/**

* @param {Enums_Leerjaar_Vijf2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaar_vijf2 = /** @type {((inputs?: Enums_Leerjaar_Vijf2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaar_Vijf2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaar_vijf2(inputs)
});
export { enums_leerjaar_vijf2 as "enums.Leerjaar.Vijf" }